import React, { useMemo, useState } from 'react';
import { FilterBar } from '../components/FilterBar';
import { mockApps } from '../utils/mockData';
import { FeaturedAppCard } from '../components/AppCard/FeaturedAppCard';
import { AppListView } from '../components/MyApps/AppListView';
import { AppTileView } from '../components/MyApps/AppTileView';
import { useAppSettings } from '../context/AppSettingsContext';
export const AllApps = () => {
  const {
    viewMode
  } = useAppSettings();
  const [filters, setFilters] = useState({
    price: '',
    category: '',
    rating: '',
    sort: 'popular'
  });
  const filteredApps = useMemo(() => {
    let apps = [...mockApps];
    if (filters.price) {
      apps = apps.filter(app => app.price.toLowerCase() === filters.price);
    }
    if (filters.category) {
      apps = apps.filter(app => app.category === filters.category);
    }
    if (filters.rating) {
      const minRating = parseInt(filters.rating);
      apps = apps.filter(app => app.rating >= minRating);
    }
    // Sort apps
    switch (filters.sort) {
      case 'newest':
        apps.sort((a, b) => new Date(b.updated).getTime() - new Date(a.updated).getTime());
        break;
      case 'rating':
        apps.sort((a, b) => b.rating - a.rating);
        break;
      default:
        // Most popular (by downloads)
        apps.sort((a, b) => parseInt(b.downloads) - parseInt(a.downloads));
    }
    return apps;
  }, [filters]);
  const renderApps = () => {
    switch (viewMode) {
      case 'list':
        return <AppListView onOpenApp={id => {}} data-id="element-521" />;
      case 'tiles':
        return <AppTileView onOpenApp={id => {}} data-id="element-522" />;
      default:
        return <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-523">
            {filteredApps.map(app => <FeaturedAppCard key={app.id} {...app} data-id="element-524" />)}
          </div>;
    }
  };
  return <div data-id="element-525">
      <FilterBar onFilterChange={setFilters} currentFilters={filters} data-id="element-526" />
      <div className="py-6 px-8" data-id="element-527">{renderApps()}</div>
    </div>;
};